export enum AvailableHoursMode {
  alwaysAvailable = 'alwaysAvailable',
  custom = 'custom',
}
